import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import SEO from "@/components/seo/SEO";
import { GoldButton, Eyebrow, SectionHeading, AmbientOrbs } from "@/components/common/ui";

export default function WhyBhtOne() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";
  const reasons = t("why.reasons", { returnObjects: true }) || [];

  return (
    <>
      <SEO title={lang === "nl" ? "Waarom BHT One" : "Why BHT One"} path="/why-bht-one" />
      <section className="relative overflow-hidden py-32 lg:py-44">
        <AmbientOrbs />
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <Eyebrow>{t("why.eyebrow")}</Eyebrow>
          <motion.h1
            initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="mt-8 max-w-5xl font-serif text-5xl leading-[1.02] tracking-tight sm:text-6xl md:text-7xl"
          >
            {t("why.h1")}
          </motion.h1>
          <p className="mt-8 max-w-2xl text-lg text-white/65">{t("why.sub")}</p>
        </div>
      </section>

      <section className="relative border-y border-white/[0.06] py-16">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="grid grid-cols-1 divide-y divide-white/[0.06] md:grid-cols-2 md:divide-y-0">
            {reasons.map((r, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 6) * 0.05, ease: [0.16, 1, 0.3, 1] }}
                className={`group flex gap-8 px-2 py-10 md:px-8 md:py-14 ${i > 0 ? "md:border-t md:border-white/[0.06]" : ""} ${i % 2 === 1 ? "md:border-l md:border-white/[0.06]" : ""}`}
                data-testid={`why-reason-${i}`}
              >
                <div className="font-mono text-[11px] tracking-widest text-bht-gold">R/{String(i + 1).padStart(2, "0")}</div>
                <div>
                  <div className="font-serif text-2xl tracking-tight transition-colors group-hover:text-bht-gold">{r.title}</div>
                  <p className="mt-3 max-w-md text-sm leading-relaxed text-white/60">{r.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-32">
        <div className="mx-auto max-w-3xl px-6 text-center lg:px-10">
          <SectionHeading align="center" eyebrow={t("brand.name")} title={t("home.cta_h")} sub={t("home.cta_sub")} />
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <GoldButton to={`/${lang}/book-demo`}>{t("cta.primary")}</GoldButton>
          </div>
        </div>
      </section>
    </>
  );
}
